<template>
    <div>
        <v-card>
            <v-card-title>Rebookings                      
                <v-spacer></v-spacer>
                <div v-if="huov_homb.length === 0"> 
                    <v-btn class="primary ma-2" x-small v-on:click="addHomb">Add new rebooking</v-btn>
                </div>
            </v-card-title>
            <span v-if="huov_homb.length === 0">
                <div class="pl-4 pt-3 pb-4">                
                    <v-label><span :class="{'text-color-error': hasError}">{{ this.resulttext }}</span></v-label>
                </div>
            </span>
            <span v-else>
                <rebooking_table :data="huov_homb" @executeFunction="executeFunction" itemtype="rebooking" class="pb-2 px-2" />
            </span>
            <viewHoor ref="viewHoor" :isVisible="showDetails" @updateField="updateField" @updateData="updateData" @executeFunction="executeFunction" class="pb-2"/>
        </v-card>
        <addUpdHomb ref="addUpdHomb" :huov_encrid="huov_encrid" @updateData="updateData"/>
        <rmHomb ref="rmHomb" :huov_encrid="huov_encrid" @updateData="updateData" @updateField="updateField"/>
        <addUpdHoor ref="addUpdHoor" :homb_encrid="homb_encrid" @updateData="updateData"/>      
        <m_attm ref="m_attm" @updateData="updateData"/>
        
    </div>
</template>

<script>

    import rebooking_table from '@/components/huov/homb/ui/homb_table.vue'
    import addUpdHomb from "@/components/huov/homb/addUpdHomb.vue";
    import viewHoor from "@/components/huov/homb/viewHoor.vue";
    import rmHomb from "@/components/huov/homb/rmHomb.vue";
    import addUpdHoor from "@/components/huov/homb/addUpdHoor.vue";
    import m_attm from "@/components/m_attm.vue";

    export default {
        mounted(){
            this.getHomb();
        },
        props: {
            huov_encrid: String,
        },        
        components: {
            rebooking_table,
            addUpdHomb,
            rmHomb,
            viewHoor,
            addUpdHoor,
            m_attm
        },      
        data() {
            return {
                huov_homb: [],
                resulttext: 'No rebookings filed',
                hasError: false,
                showDetails: false,
                homb_encrid: '',
            }
        },
        methods: {         
            executeFunction(data){
                this.homb_encrid = data[1].value;
                // console.log(data);
                switch(data[0].value){
                    case 'update_rebooking':
                        this.$refs.addUpdHomb.open_dialog(data[1].value, data[2].value);
                        break;
                    case 'delete_rebooking':
                        this.$refs.rmHomb.open(data[1].value, data[2].value);
                        break;    
                    case 'open_rebooking':     
                        this.$refs.viewHoor.open(data[1].value, data[2].value);
                        break;
                    case 'add_upd_rebooking_event': 
                        this.$refs.addUpdHoor.open(data[2].value);
                        break;
                    case 'attachments_rebooking':
                        this.hombAttm(data[2].value);
                        break;                            
                }
            },               
            getHomb(){
                //console.log('getHomb');
                this.$axios.post("ares/json/ares/huov/homb/getHomb.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHomb"
                    },
                    getHomb: {
                        huov_encrid: this.huov_encrid
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                        this.resulttext = res.data.error.message;
                        this.hasError = true;
                    } else {                   
                        this.huov_homb = res.data.huov_homb.homb;         
                        this.hasError = false;
                    }
                });   
            },               
            addHomb(){
                this.$refs.addUpdHomb.open_dialog("", "");
            },            
            updateField(data){
                this[data.field]=data.value;
            },
            updateData(){
                this.getHomb();
                if(this.showDetails){ // get details if they are visible
                    this.$refs.viewHoor.getHoor(this.homb_encrid);
                }
                this.$emit('updateData', 'refresh'); // send refresh to parent
            },
            hombAttm(homb_code){
                this.$refs.m_attm.open('homb', homb_code, '', '', this.homb_encrid, 0);
            }            
        }
    }
</script>

<style scoped>
    .text-color-error{
        color: red;
    }
    .v-label{
        color: '';
    }
</style>